var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.765 27.0703C110.058 27.0703 111.108 28.1203 111.108 29.4141C111.108 30.7078 110.058 31.7578 108.765 31.7578C107.471 31.7578 106.421 30.7078 106.421 29.4141C106.421 28.1203 107.471 27.0703 108.765 27.0703Z",
    fill: "#28A1D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.765 88.0078C110.058 88.0078 111.108 89.0578 111.108 90.3516C111.108 91.6453 110.058 92.6953 108.765 92.6953C107.471 92.6953 106.421 91.6453 106.421 90.3516C106.421 89.0578 107.471 88.0078 108.765 88.0078Z",
    fill: "#005E9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0459 102.07C99.6357 102.07 101.733 104.168 101.733 106.758C101.733 109.348 99.6357 111.445 97.0459 111.445C94.4561 111.445 92.3584 109.348 92.3584 106.758C92.3584 104.168 94.4561 102.07 97.0459 102.07Z",
    fill: "#28A1D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3584 5.97656C93.6521 5.97656 94.7021 7.02656 94.7021 8.32031C94.7021 9.61406 93.6521 10.6641 92.3584 10.6641C91.0646 10.6641 90.0146 9.61406 90.0146 8.32031C90.0146 7.02656 91.0646 5.97656 92.3584 5.97656Z",
    fill: "#28A1D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5459 13.0078C33.6568 13.0078 12.6709 33.9937 12.6709 59.8828C12.6709 85.7719 33.6568 106.758 59.5459 106.758C85.435 106.758 106.421 85.7719 106.421 59.8828C106.421 33.9937 85.435 13.0078 59.5459 13.0078Z",
    fill: "#005E9A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5459 95.0391C40.1303 95.0391 24.3896 79.2984 24.3896 59.8828C24.3896 40.4672 40.1303 24.7266 59.5459 24.7266C78.9615 24.7266 94.7021 40.4672 94.7021 59.8828C94.7021 79.2984 78.9615 95.0391 59.5459 95.0391Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9714 48.8017C78.8021 50.6321 78.8021 53.5993 76.9714 55.4298L60.3988 72.0048L53.7707 78.6329L47.1402 72.0048L42.1691 67.0313C41.2553 66.1173 40.7959 64.9173 40.7959 63.7173C40.7959 62.5173 41.2553 61.3173 42.1691 60.403C43.9998 58.5725 46.967 58.5725 48.7972 60.403L53.7707 65.3741L70.3436 48.8017C71.26 47.8876 72.4576 47.4282 73.6576 47.4282C74.8576 47.4282 76.0553 47.8876 76.9714 48.8017Z",
    fill: "#005E9A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3896 106.758C25.6834 106.758 26.7334 107.808 26.7334 109.102C26.7334 110.395 25.6834 111.445 24.3896 111.445C23.0957 111.445 22.0459 110.395 22.0459 109.102C22.0459 107.808 23.0957 106.758 24.3896 106.758Z",
    fill: "#005E9A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5303 10.6641C21.767 10.6641 24.3896 13.2867 24.3896 16.5234C24.3896 19.7602 21.767 22.3828 18.5303 22.3828C15.2933 22.3828 12.6709 19.7602 12.6709 16.5234C12.6709 13.2867 15.2933 10.6641 18.5303 10.6641Z",
    fill: "#28A1D4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3271 29.4141C11.6209 29.4141 12.6709 30.4641 12.6709 31.7578C12.6709 33.0516 11.6209 34.1016 10.3271 34.1016C9.03316 34.1016 7.9834 33.0516 7.9834 31.7578C7.9834 30.4641 9.03316 29.4141 10.3271 29.4141Z",
    fill: "#005E9A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3271 88.0078C11.6209 88.0078 12.6709 89.0578 12.6709 90.3516C12.6709 91.6453 11.6209 92.6953 10.3271 92.6953C9.03316 92.6953 7.9834 91.6453 7.9834 90.3516C7.9834 89.0578 9.03316 88.0078 10.3271 88.0078Z",
    fill: "#28A1D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.85e57ec6.svg";
export { ForwardRef as ReactComponent };